const TTL = 7 * 24 * 60 * 60 * 1000;
const META = "__ls_written_at";
const { getItem, setItem, removeItem } = Storage.prototype;
const isLocal = (s) => { try { return s === window.localStorage; } catch { return false; } };
const stamps = () => { try { return JSON.parse(getItem.call(localStorage, META)) || {}; } catch { return {}; } };
const save = (m) => { try { setItem.call(localStorage, META, JSON.stringify(m)); } catch {} };
const expired = (m, k) => m[k] && Date.now() - m[k] > TTL;

Storage.prototype.setItem = function (k, v) {
  setItem.call(this, k, v);
  if (isLocal(this) && k !== META) { const m = stamps(); m[k] = Date.now(); save(m); }
};

Storage.prototype.removeItem = function (k) {
  removeItem.call(this, k);
  if (isLocal(this)) { const m = stamps(); delete m[k]; save(m); }
};

Storage.prototype.getItem = function (k) {
  if (isLocal(this) && k !== META && expired(stamps(), k)) { this.removeItem(k); return null; }
  return getItem.call(this, k);
};

try {
  const m = stamps();
  Object.keys(localStorage).forEach((k) => {
    if (k === META) return;
    if (!m[k]) m[k] = Date.now();
    else if (expired(m, k)) { removeItem.call(localStorage, k); delete m[k]; }
  });
  Object.keys(m).forEach((k) => { if (getItem.call(localStorage, k) === null) delete m[k]; });
  save(m);
} catch {}
